module.exports = __webpack_public_path__ + "static/img/simplifySales.30fd73f0.png";